/**
 * SECTION 5A JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
import aon_craft_step_navigation from './aon_craft_step_navigation.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Section 5A, data
         * UI interaction functions etc
         */
        console.log( 'Section 5A - init' );
        
        //var where_do_you_take_inspiration = '';
        
        this.aon_section_5a_data = [];
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_live' );
            
        } else { // If not Business Plan page then we are in 1A...
            if ( $( '#section_5a_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
        
        // Init Tasks, Impacts, Issues selected arrays
        this.tasks_applied_array = [];
        this.impacts_applied_array = [];
        this.issues_applied_array = [];
        this.selected_task_impact_issue_array = { 'task': '', 'impact': '', 'issue': '', 'task_badge_id': '', 'impact_badge_id': '', 'issue_badge_id': '' };
        this.business_purpose_statement = '';
        
        var selected_task_counter = 0;
        var selected_impact_counter = 0;
        var selected_issue_counter = 0;
        
        // Add local function to render task from within functions
        var callRenderTaskImpactIssueEntries = ( mode ) => {
            this.renderTaskImpactIssueEntries( mode );
            //console.log( 'this.renderTaskImpactIssueEntries( mode )' );
        }
        
        // Check length of list arrays is at least 3
        var checkLengthOfAppliedItemsArray = ( mode ) => {
            var item_array;
            if ( mode == 'tasks' ) {
                item_array = this.tasks_applied_array;
                if ( item_array.length == 3 ) {
                    $( '.add_tasks_next' ).removeClass( 'disabled' );
                    $( '.lozenge_task_add' ).addClass( 'disabled' );
                    // Disable interaction on existing default lozenges
                    $( '.tasks_section5 .lozenge_item' ).addClass( 'all-applied' );
                } else {
                    $( '.add_tasks_next' ).addClass( 'disabled' );
                    $( '.lozenge_task_add' ).removeClass( 'disabled' );
                    // Re-enable interaction on existing default lozenges
                    $( '.tasks_section5 .lozenge_item' ).removeClass( 'all-applied' );
                    // Deleting an item means that not all applied items are set so we need to disable next button on the `Your tasks, impacts & issues` steps
                    $( '.set_selected_task_impacts_issues_next' ).addClass( 'disabled' );
                }
                
            } else if ( mode == 'impacts' ) {
                item_array = this.impacts_applied_array;
                if ( item_array.length == 3 ) {
                    $( '.add_impacts_next' ).removeClass( 'disabled' );
                    $( '.lozenge_impact_add' ).addClass( 'disabled' );
                    // Disable interaction on existing default lozenges
                    $( '.impacts_section5 .lozenge_item' ).addClass( 'all-applied' );
                } else {
                    $( '.add_impacts_next' ).addClass( 'disabled' );
                    $( '.lozenge_impact_add' ).removeClass( 'disabled' );
                    // Re-enable interaction on existing default lozenges
                    $( '.impacts_section5 .lozenge_item' ).removeClass( 'all-applied' );
                    // Deleting an item means that not all applied items are set so we need to disable next button on the `Your tasks, impacts & issues` steps
                    $( '.set_selected_task_impacts_issues_next' ).addClass( 'disabled' );
                }
                
            } else if ( mode == 'issues' ) {
                item_array = this.issues_applied_array;
                if ( item_array.length == 3 ) {
                    $( '.add_issues_next' ).removeClass( 'disabled' );
                    $( '.lozenge_issue_add' ).addClass( 'disabled' );
                    // Disable interaction on existing default lozenges
                    $( '.issues_section5 .lozenge_item' ).addClass( 'all-applied' );
                } else {
                    $( '.add_issues_next' ).addClass( 'disabled' );
                    $( '.lozenge_issue_add' ).removeClass( 'disabled' );
                    // Re-enable interaction on existing default lozenges
                    $( '.issues_section5 .lozenge_item' ).removeClass( 'all-applied' );
                    // Deleting an item means that not all applied items are set so we need to disable next button on the `Your tasks, impacts & issues` steps
                    $( '.set_selected_task_impacts_issues_next' ).addClass( 'disabled' );
                }
            }
        }

        
        // Add to applied Tasks, Impacts, Issues arrays...
        var pushToTaskImpactIssueEntriesArray = ( name, mode, badge_id ) => {
            if ( mode == 'tasks' ) {
                this.tasks_applied_array.push( { name: name.trim(), badge_id: badge_id } );
                // Check we haven't reached max 3 entries 
                checkLengthOfAppliedItemsArray( mode );
                console.table( this.tasks_applied_array );
                
            } else if ( mode == 'impacts' ) {
                this.impacts_applied_array.push( { name: name.trim(), badge_id: badge_id } );
                // Check we haven't reached max 3 entries
                checkLengthOfAppliedItemsArray( mode );
                console.table( this.impacts_applied_array );
                
            } else if ( mode == 'issues' ) {
                this.issues_applied_array.push( { name: name.trim(), badge_id: badge_id } );
                // Check we haven't reached max 3 entries
                checkLengthOfAppliedItemsArray( mode );
                console.table( this.issues_applied_array );
            }
            
        }
        // Remove from applied Tasks, Impacts, Issues arrays...
        var removeFromTaskImpactIssueEntriesArray = ( id, mode, name ) => {
            if ( mode == 'tasks' ) {
                this.tasks_applied_array.splice( id, 1 );
                this.renderTaskImpactIssueEntries( mode );
                checkLengthOfAppliedItemsArray( mode );
                //console.table( this.tasks_applied_array );
                
            } else if ( mode == 'impacts' ) {
                this.impacts_applied_array.splice( id, 1 );
                this.renderTaskImpactIssueEntries( mode );
                checkLengthOfAppliedItemsArray( mode );
                //console.table( this.impacts_applied_array );
                
            } else if ( mode == 'issues' ) {
                this.issues_applied_array.splice( id, 1 );
                this.renderTaskImpactIssueEntries( mode );
                checkLengthOfAppliedItemsArray( mode );
                //console.table( this.issues_applied_array );
            }
            
        }
        
        // Set selected Task, Impact, Issue to final `selected_task_impact_issue_array` array items...
        var setSelectedTaskImpactIssueArray = ( name, mode, badge_id ) => {
            // Get badge_id if defined...
            //var badge_id = '';
            //if ( badge_id ) {
            //    badge_id = badge_id.trim();
            //}
            //console.log( '------------------------------------------------' );
            //console.log( 'SET BADGE_ID IN setSelectedTaskImpactIssueArray' );
            //console.log( 'badge_id: ' + badge_id );
            //console.log( '------------------------------------------------' );
            
            if ( mode == 'tasks' ) {
                this.selected_task_impact_issue_array[ 'task' ] = name.trim();
                this.selected_task_impact_issue_array[ 'task_badge_id' ] = badge_id;
                var selected_task = '';
                selected_task_counter = 0;
                
                // Clear all `selected` classes from applied `tasks` list...
                $( '.purpose-circle-triple-content .tasks_applied a.lozenge_item' ).removeClass( 'selected' );
                
                // Reset selected item in `tasks` dropdown...
                $( '#tasks_dropdown' ).val(0);
                
                $( '.purpose-circle-triple-content .tasks_applied a.lozenge_item' ).each(function() {
                    // loop over applied list and see if there is a match
                    if ( $( this ).text() == name.trim() ) {
                        $( this ).addClass( 'selected' );
                        selected_task = $( this );
                        selected_task_counter = 1;
                        // Set the same match in the `tasks_dropdown...
                        $( '#tasks_dropdown' ).val( name.trim() );
                        // Set the text in the `statement_task` span in the purpose statement...
                        $( '.statement_task' ).text( name.trim().toLowerCase() );
                    }
                });
                // Set any active badges
                //setBadges(); Note: Tasks don't currently set badges so this doesn't get called
                
            } else if ( mode == 'impacts' ) {
                this.selected_task_impact_issue_array[ 'impact' ] = name.trim();
                this.selected_task_impact_issue_array[ 'impact_badge_id' ] = badge_id;
                var selected_impact = '';
                selected_impact_counter = 0;
                // Clear all `selected` classes from applied `impacts` list...
                $( '.purpose-circle-triple-content .impacts_applied a.lozenge_item' ).removeClass( 'selected' );
                
                // Reset selected item in `impacts` dropdown...
                $( '#impacts_dropdown' ).val(0);
                
                $( '.purpose-circle-triple-content .impacts_applied a.lozenge_item' ).each(function() {
                    // loop over applied list and see if there is a match
                    if ( $( this ).text() == name.trim() ) {
                        $( this ).addClass( 'selected' );
                        selected_impact = $( this );
                        selected_impact_counter = 1;
                        // Set the same match in the `impacts_dropdown...
                        $( '#impacts_dropdown' ).val( name.trim() );
                        // Set the text in the `statement_impact` span in the purpose statement...
                        $( '.statement_impact' ).text( name.trim().toLowerCase() );
                    }
                });
                // Set any active badges
                setBadges();
                
            } else if ( mode == 'issues' ) {
                this.selected_task_impact_issue_array[ 'issue' ] = name.trim();
                this.selected_task_impact_issue_array[ 'issue_badge_id' ] = badge_id;
                var selected_issue = '';
                selected_issue_counter = 0;
                // Clear all `selected` classes from applied `issues` list...
                $( '.purpose-circle-triple-content .issues_applied a.lozenge_item' ).removeClass( 'selected' );
                
                // Reset selected item in `issues` dropdown...
                $( '#issues_dropdown' ).val(0);
                
                $( '.purpose-circle-triple-content .issues_applied a.lozenge_item' ).each(function() {
                    // loop over applied list and see if there is a match
                    if ( $( this ).text() == name.trim() ) {
                        $( this ).addClass( 'selected' );
                        selected_issue = $( this );
                        selected_issue_counter = 1;
                        // Set the same match in the `issues_dropdown...
                        $( '#issues_dropdown' ).val( name.trim() );
                        // Set the text in the `statement_issue` span in the purpose statement...
                        $( '.statement_issue' ).text( name.trim().toLowerCase() );
                    }
                });
                // Set any active badges
                setBadges();
                
            }
            
            var tii_count = selected_task_counter + selected_impact_counter + selected_issue_counter;
            if ( tii_count == 3 ) {
                $( '.set_selected_task_impacts_issues_next' ).removeClass( 'disabled' );
            } else {
                $( '.set_selected_task_impacts_issues_next' ).addClass( 'disabled' );
            }
            
            $( '.task-impact-issues-selected-count .tii_count' ).text( tii_count );
            
            // Compile Business Purpose Statement string...
            this.business_purpose_statement = $( '.bps_1' ).text() + ' ' + $( '.bps_2' ).text() + ' ' + $( '.bps_3' ).text();
            //this.business_purpose_statement = $( '.bps_1' ).text() + ' ' + $( '.statement_issue' ).text() + ' ' + $( '.bps_2' ).text() + ' ' + $( '.statement_impact' ).text() + '. ' + $( '.bps_3' ).text() + ' ' + $( '.statement_task' ).text() + '.';
            
            console.log( 'setSelectedTaskImpactIssueArray' );
            console.table( this.selected_task_impact_issue_array );
        }
        
        
        // SET ANY ACTIVE BADGES BASED ON SELECTED ITEMS
        var setBadges = ( ) => {
            var badge_count = 0;
            $( '.badge_count' ).text( badge_count );
            var issue_badge_id = this.selected_task_impact_issue_array[ 'issue_badge_id' ];
            var impact_badge_id = this.selected_task_impact_issue_array[ 'impact_badge_id' ];
            if ( issue_badge_id != '' ) {
                var badge_target_content = $( '.sustainability-badges-container-source .sustainability-badge[data-badge-id="' + issue_badge_id + '"]' ).html();
                $( '.sustainability-badges-container .sustainability-badge-target-issues' ).html( badge_target_content ).addClass( 'active' );
                badge_count++;
                $( '.badge_count' ).text( badge_count );
            } else {
                $( '.sustainability-badges-container .sustainability-badge-target-issues' ).html( '' ).removeClass( 'active' );
            }
            if ( impact_badge_id != '' ) {
                var badge_target_content = $( '.sustainability-badges-container-source .sustainability-badge[data-badge-id="' + impact_badge_id + '"]' ).html();
                $( '.sustainability-badges-container .sustainability-badge-target-impacts' ).html( badge_target_content ).addClass( 'active' );
                badge_count++;
                $( '.badge_count' ).text( badge_count );
            } else {
                $( '.sustainability-badges-container .sustainability-badge-target-impacts' ).html( '' ).removeClass( 'active' );
            }
            
            // Change Purpose Statement screen's `Next` button destination if 0 badges earned,
            // and Final `Completed...` screen's Back button if more > 0 badges earned
            if ( badge_count == 0 ) {
                $( '.purpose_statement_next' ).addClass( 'zero_badges_skip_next' );
                $( '.completed_back' ).removeClass( 'badges_skip_back' );
            } else {
                $( '.purpose_statement_next' ).removeClass( 'zero_badges_skip_next' );
                $( '.completed_back' ).addClass( 'badges_skip_back' );
            }
            
        }
        //
        // If ZERO badges have been earned then we skip the Earned badges screen on Step 14
        // and go to the alternative `Congratulations` screen instead.
        $( 'body' ).on( 'click', '.zero_badges_skip_next', function( event ) {
            aon_craft_step_navigation.changeStep( 15 );
            event.preventDefault();
        });
        //
        // If ZERO badges have been earned then the user sees the alternative `Congratulations` screen, 
        // so we need to override the default back button functionality on its Back button to go back to Step 13.
        $( 'body' ).on( 'click', '.zero_badges_skip_back', function( event ) {
            aon_craft_step_navigation.changeStep( 13 );
            event.preventDefault();
        });
        //
        // If > 0 badges have been earned then the user sees the main `Badges` screen, so we need to 
        // skip the alternative `Congratulations` screen which sequentially is the next screen in the flow.
        $( 'body' ).on( 'click', '.badges_earned_next', function( event ) {
            aon_craft_step_navigation.changeStep( 16 );
            event.preventDefault();
        });
        // If > 0 badges have been earned then the user needs to skip the alternative 
        // `Congratulations` screen which sequentially is the previous screen in the flow.
        $( 'body' ).on( 'click', '.badges_skip_back', function( event ) {
            aon_craft_step_navigation.changeStep( 14 );
            event.preventDefault();
        });
        
        
        // Load saved Task, Impact, Issue entries
        var loadSavedTaskImpactIssueEntries = ( mode ) => { // Function defined using arrow method to gain access to main 'this'

            $.each( this.aon_section_5a_data, function( index, value ) {
                //console.log( 'index - value: ' + index + ' - ' + value.tasks_items );
                var item_array;
                if ( mode == 'tasks' ) {
                    item_array = this.tasks_items;
                } else if ( mode == 'impacts' ) {
                    item_array = this.impacts_items;
                } else if ( mode == 'issues' ) {
                    item_array = this.issues_items;
                }
                
                // Set Tasks, Impacts, Issues array data
                $.each( item_array, function( index, value ) {
                    
                    if ( mode == 'tasks' ) {
                        pushToTaskImpactIssueEntriesArray( value.name, 'tasks', value.badge_id );
                        
                        // Call local function to render task from within functions
                        callRenderTaskImpactIssueEntries( 'tasks' );
                        //console.table( this.tasks_applied_array );

                    } else if ( mode == 'impacts' ) {
                        pushToTaskImpactIssueEntriesArray( value.name, 'impacts', value.badge_id );
                        
                        // Call local function to render task from within functions
                        callRenderTaskImpactIssueEntries( 'impacts' );
                        //console.table( this.impacts_applied_array );

                    } else if ( mode == 'issues' ) {
                        pushToTaskImpactIssueEntriesArray( value.name, 'issues', value.badge_id );
                        
                        // Call local function to render task from within functions
                        callRenderTaskImpactIssueEntries( 'issues' );
                        //console.table( this.issues_applied_array );
                    }
                    
                });
                
            });

        }
        
        // Set active Task, Impact, Issue entries
        var setActiveTaskImpactIssueEntries = ( mode ) => {
            
            // Get `selected_task_impact_issue_items` and assign to local `selected_task_impact_issue_array` array
            if ( this.aon_section_5a_data[0].selected_task_impact_issue_items && mode == 'tasks' ) {
                setSelectedTaskImpactIssueArray( this.aon_section_5a_data[0].selected_task_impact_issue_items.task, 'tasks', this.aon_section_5a_data[0].selected_task_impact_issue_items.task_badge_id );
            }
            if ( this.aon_section_5a_data[0].selected_task_impact_issue_items && mode == 'impacts' ) {
                setSelectedTaskImpactIssueArray( this.aon_section_5a_data[0].selected_task_impact_issue_items.impact, 'impacts', this.aon_section_5a_data[0].selected_task_impact_issue_items.impact_badge_id );
            }
            if ( this.aon_section_5a_data[0].selected_task_impact_issue_items && mode == 'issues' ) {
                setSelectedTaskImpactIssueArray( this.aon_section_5a_data[0].selected_task_impact_issue_items.issue, 'issues', this.aon_section_5a_data[0].selected_task_impact_issue_items.issue_badge_id );
            }

        }
        
        loadSavedTaskImpactIssueEntries( 'tasks' );
        loadSavedTaskImpactIssueEntries( 'impacts' );
        loadSavedTaskImpactIssueEntries( 'issues' );
        
        // Render Data...
        this.renderData();
        
        this.renderTaskImpactIssueEntries( 'tasks' );
        this.renderTaskImpactIssueEntries( 'impacts' );
        this.renderTaskImpactIssueEntries( 'issues' );
        
        setActiveTaskImpactIssueEntries( 'tasks' );
        setActiveTaskImpactIssueEntries( 'impacts' );
        setActiveTaskImpactIssueEntries( 'issues' );
        
        checkLengthOfAppliedItemsArray( 'tasks' );
        checkLengthOfAppliedItemsArray( 'impacts' );
        checkLengthOfAppliedItemsArray( 'issues' );
                
        $( 'body' ).on( 'change', '.dropdown-container select', function( event ) {
            var mode = aon_craft_utils.removeHTMLTags( $( this ).attr( 'id' ).replace( '_dropdown', '' ) );
            
            //console.log( "$( 'option:selected', this ).attr( 'data-badge-id' )" );
            //console.log( $( 'option:selected', this ).attr( 'data-badge-id' ) );
            
            if ( mode == 'tasks' ) {
                // Set the text in the `statement_task` span in the purpose statement...
                setSelectedTaskImpactIssueArray( $( 'option:selected', this ).val(), 'tasks', $( 'option:selected', this ).attr( 'data-badge-id' ) );
                
            } else if ( mode == 'impacts' ) {
                // Set the text in the `statement_impact` span in the purpose statement...
                setSelectedTaskImpactIssueArray( $( 'option:selected', this ).val(), 'impacts', $( 'option:selected', this ).attr( 'data-badge-id' ) );
                
            } else if ( mode == 'issues' ) {
                // Set the text in the `statement_issue` span in the purpose statement...
                setSelectedTaskImpactIssueArray( $( 'option:selected', this ).val(), 'issues', $( 'option:selected', this ).attr( 'data-badge-id' ) );
                
            }
            console.log( 'change -- .dropdown-container select' );
            console.log( 'mode: ' + mode );
            console.log( $( this ).val() );
            event.preventDefault();
        });
                
        $( 'body' ).on( 'click', '.grid-x4-panel', function( event ) {
            $( this ).addClass( 'active' );
            $( '.grid-x4-panel' ).each(function() {
                if ( $( this ).hasClass( 'active' ) ) {
                    $( '.people-planet-next' ).removeClass( 'disabled' );
                } else {
                    $( '.people-planet-next' ).addClass( 'disabled' );
                }
            });
            event.preventDefault();
        });

        $( 'body' ).on( 'click', '.grid-x1-panel', function( event ) {
            $( this ).addClass( 'active' );
            $( '.did-you-know-text' ).removeClass( 'hide' );
            $( '.did-you-know-next' ).removeClass( 'disabled' );
            event.preventDefault();
        });
        
        
        // Tasks, Impacts, Issues
        $( '.add_new_task_impact_issue' ).on( 'click', function( event ) {
            if ( !$( this ).hasClass( 'disabled' ) ) {
                var mode = $( this ).attr( 'href' ).replace( '#add-', '' );
                console.log( mode );
                var badge_id = ''; // Note: As we are adding a new item it doesn't have a badge ID, but this could be supported if the modal allowed the user to set the category of the item added
                // Set title for H3
                $( '#add_new_task_impact_issue_modal h3 span' ).hide();
                $( '#add_new_task_impact_issue_modal h3 span.' + mode ).show();
                // Set title for Label
                $( '#add_new_task_impact_issue_modal label span' ).hide();
                $( '#add_new_task_impact_issue_modal label span.' + mode ).show();
                // Set hidden `add_new_task_impact_issue_modal_mode` field value
                $( '#add_new_task_impact_issue_modal_mode' ).val( mode );
                // Set hidden `add_new_task_impact_issue_modal_badge_id` field value
                $( '#add_new_task_impact_issue_modal_badge_id' ).val( badge_id );
                $( '#add_new_task_impact_issue_modal' ).foundation( 'open' );
            }
            event.preventDefault();
        });
        
        $( '#add_new_task_impact_issue_modal' ).on( 'open.zf.reveal', function() {
            $( '#add_new_task_impact_issue_modal input[type="text"]' ).val( '' );
            $( '#add_new_task_impact_issue_modal input[type="text"]' ).focus();
        });

        $( '#add_new_task_impact_issue_modal' ).on( 'closed.zf.reveal', function() {
            $( '#add_new_task_impact_issue_modal input[type="text"]' ).val( '' );
            $( '#add_new_task_impact_issue_modal_mode' ).val( '' );
        });

        $( 'body' ).on( 'click', '.lozenges_selector .add', function( event ) {
            event.preventDefault();
        });
        
        //
        // ADDING / REMOVING TASK / IMPACT / ISSUE VIA `ADD` BUTTON OR EXISTING LOZENGE BUTTON
        //
        // Add task / impact / issue to list via Save button in "Add a..." modal...
        $( '#save_add_new_task_impact_issue' ).on( 'click', function( event ) {
            var new_task_impact_issue_item = aon_craft_utils.removeHTMLTags( $( '#add_new_task_impact_issue_modal input[type="text"]' ).val() );
            var mode = aon_craft_utils.removeHTMLTags( $( '#add_new_task_impact_issue_modal_mode' ).val() );
            var badge_id = aon_craft_utils.removeHTMLTags( $( '#add_new_task_impact_issue_modal_badge_id' ).val() );
            //pushToTaskImpactIssueEntriesArray( new_task_impact_issue_item, mode, badge_id );
            //callRenderTaskImpactIssueEntries( mode );
            //console.log( '#save_add_new_task_impact_issue: ' + new_task_impact_issue_item + ' - ' + mode );
            
            if ( mode == 'tasks' ) {
                // Get the 'data-tasks-entry-id' of the last existing Task item...
                var last_task_id = $( '.tasks_section5 li' ).last().children( 'a' ).attr( 'data-tasks-entry-id' );
                var new_task_entry_id = Number( last_task_id ) + 2;
                var new_task_id = Number( last_task_id ) + 1;
                var new_task_link = '<a href="#add-to-list" data-tasks-entry-id="' + new_task_id + '" class="button rounded lozenge_item entry_' + new_task_entry_id + '">' + new_task_impact_issue_item.trim() + '</a>';
                $( '.tasks_section5' ).append( '<li class="tasks_entry">' + new_task_link + '</li>' );

            } else if ( mode == 'impacts' ) {
                // Get the 'data-badge-id' of the last existing Impact item...
                //var last_impact_id = $( '.impacts_section5 li' ).last().children( 'a' ).attr( 'data-badge-id' );
                //var new_impact_id = Number( last_impact_id ) + 1;
                var new_impact_link = '<a href="#add-to-list" class="button rounded lozenge_item" data-badge-id="">' + new_task_impact_issue_item.trim() + '</a>';
                $( '.impacts_section5' ).append( '<li>' + new_impact_link + '</li>' );

            } else if ( mode == 'issues' ) {
                // Get the 'data-badge-id' of the last existing Issue item...
                //var last_issue_id = $( '.issues_section5 li' ).last().children( 'a' ).attr( 'data-badge-id' );
                //var new_issue_id = Number( last_issue_id ) + 1;
                var new_issue_link = '<a href="#add-to-list" class="button rounded lozenge_item" data-badge-id="">' + new_task_impact_issue_item.trim() + '</a>';
                $( '.issues_section5' ).append( '<li>' + new_issue_link + '</li>' );
                
            }
            
            event.preventDefault();
        });
        //
        // Add task_impact_issue_item to list via Click on one of the existing task_impact_issue_item lozenge items...
        $( 'body' ).on( 'click', '.lozenge_item', function( event ) {
            if ( !$( this ).hasClass( 'all-applied' ) ) {
                var parent = $( this ).parents( '.lozenges' );
                var mode;
                var badge_id = $( this ).attr( 'data-badge-id' );
                if ( parent.hasClass( 'tasks_section5' ) ) {
                    mode = 'tasks';
                } else if ( parent.hasClass( 'impacts_section5' ) ) {
                    mode = 'impacts';
                } else if ( parent.hasClass( 'issues_section5' ) ) {
                    mode = 'issues';
                }
                var new_task_impact_issue_item = $( this ).text();

                if ( new_task_impact_issue_item !== '' ) {
                    pushToTaskImpactIssueEntriesArray( new_task_impact_issue_item, mode, badge_id );
                    callRenderTaskImpactIssueEntries( mode );
                }
            }
            event.preventDefault();
        });
        //
        // Remove task_impact_issue_item from `applied` list via Click on one of the selected task_impact_issue_item lozenge items...
        $( 'body' ).on( 'click', '.purpose-circle-single .list_applied a', function( event ) { // Note only clicks on `.list_applied a` within `.purpose-circle-single` will remove entries
            var parent = $( this ).parents( '.list_applied' );
            var name = $( this ).text();
            var mode;
            if ( parent.hasClass( 'tasks_applied' ) ) {
                mode = 'tasks';
            } else if ( parent.hasClass( 'impacts_applied') ) {
                mode = 'impacts';
            } else if ( parent.hasClass( 'issues_applied') ) {
                mode = 'issues';
            }
            console.log( 'delete_task_impact_issue_item_index' );
            var delete_task_impact_issue_item_index = $( this ).attr( 'data-applied-item-index' );
            if ( delete_task_impact_issue_item_index !== '' ) {
                removeFromTaskImpactIssueEntriesArray( delete_task_impact_issue_item_index, mode, name.trim() );
            }
            
            event.preventDefault();
        });
        
        // Select final task / impacts / issues items from their `list_applied` list via Click...
        $( 'body' ).on( 'click', '.purpose-circle-triple .list_applied a', function( event ) { // Note only clicks on `.list_applied a` within `.purpose-circle-single` will remove entries
            var parent = $( this ).parents( '.list_applied' );
            var name = aon_craft_utils.removeHTMLTags( $( this ).text() );
            var mode;
            // Get badge_id if set...
            var badge_id = aon_craft_utils.removeHTMLTags( $( this ).attr( 'data-badge-id' ) );
            if ( parent.hasClass( 'tasks_applied' ) ) {
                mode = 'tasks';
            } else if ( parent.hasClass( 'impacts_applied') ) {
                mode = 'impacts';
            } else if ( parent.hasClass( 'issues_applied') ) {
                mode = 'issues';
            }
            
            //console.log( 'Final task / impacts / issues: name - ' + name + ' : mode - ' + mode );
            
            if ( name !== '' ) {
                setSelectedTaskImpactIssueArray( name.trim(), mode, badge_id );
            }
            
            //console.log( '------------------------------------------------' );
            //console.log( "SET BADGE_ID IN $( 'body' ).on( 'click', '.purpose-circle-triple .list_applied a'" );
            //console.log( 'badge_id: ' + badge_id );
            //console.log( $( this ) );
            //console.log( '------------------------------------------------' );
            
            event.preventDefault();
        });
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
          

    },
    
    renderTaskImpactIssueEntries( mode ) {
        /*
         * Load / render existing task_impact_issue_items to list...
         */
        //console.log( 'renderTaskImpactIssueEntries - start' );
        //console.table( this.aon_section_5a_data );  
        
        
        var checkIfMatchInDefaultItems = ( mode ) => {
            var default_list;
            var applied_list;
            if ( mode == 'tasks' ) {
                default_list = '.tasks_section5';
                applied_list = '.tasks_applied';
                
            } else if ( mode == 'impacts' ) {
                default_list = '.impacts_section5';
                applied_list = '.impacts_applied';
                
            } else if ( mode == 'issues' ) {
                default_list = '.issues_section5';
                applied_list = '.issues_applied';
                
            }
            
            //console.log( 'checkIfMatchInDefaultItems' );
            
            // Remove all `applied` classes from default list first
            $( default_list + ' li a.lozenge_item' ).removeClass( 'applied' ); 
            // Loop over default list...
            $( default_list + ' li a.lozenge_item' ).each(function() {
                var default_list_item = $( this );
                // loop over applied list and see if there is a match
                $( applied_list + ' li a.lozenge_item' ).each(function() {
                    //console.log( default_list_item.text() + ' - ' + $( this ).text() );
                    if ( $( this ).text() == default_list_item.text() ) {
                        //console.log( ' ---- -They match: ' + $( this ).text() + ' - ' + default_list_item.text() );
                        default_list_item.addClass( 'applied' );
                    } else {
                        //console.log( 'They DONT match' );
                    }
                });
            });
        }
        
        
        // Remove any existing entries from lists so that we don't re-render...
        $( '.list_applied.' + mode + '_applied li' ).remove();
        // Remove any existing entries from dropdowns so that we don't re-render...
        $( '#' + mode + '_dropdown option' ).remove();
   
        // Begin entry...   
        var render_array;
        if ( mode == 'tasks' ) {
            render_array = this.tasks_applied_array;
        } else if ( mode == 'impacts' ) {
            render_array = this.impacts_applied_array;
        } else if ( mode == 'issues' ) {
            render_array = this.issues_applied_array;
        } 

        // Loop over data array...
        var entry_count = 1;
        $.each( render_array, function( index, value ) {
            // Get badge_id if set...
            var badge_id = '';
            if ( value.badge_id ) {
                badge_id = value.badge_id.trim();
            }
            
            // Render to lists...
            var aon_task_impact_issue_item = '<a href="#word_entry" class="button rounded lozenge_item entry_' + entry_count + '" data-applied-item-num="' + entry_count + '" data-applied-item-index="' + index + '" data-badge-id="' + badge_id + '">' + value.name.trim() + '</a>';
            $( '.list_applied.' + mode + '_applied' ).append( '<li>' + aon_task_impact_issue_item + '</li>' );
            // Render to dropdowns in purpose statement...
            console.log( 'Render to dropdowns in purpose statement...' );
            console.log( '#' + mode + '_dropdown option: ' + value.name.trim() );
            $( '#' + mode + '_dropdown' ).append( '<option value="' + value.name.trim() + '" data-badge-id="' + badge_id + '">' + value.name.trim() + '</option>');
            entry_count++;
        });
        
        
        // Check if items match in both lists and set `applied` class
        checkIfMatchInDefaultItems( mode );
        
        //console.log( 'renderTaskImpactIssueEntries - end' );

    },
    
    loadTasksDataFrom2c() {
        // Load 2C's JSON array data in page if not empty
        if ( $( '#section_2c_data_json' ).val() != '' ) {
            var aon_section_2c_data_json = $( '#section_2c_data_json' ).val();
        } else {
            var aon_section_2c_data_json = '[]';
        }
        this.aon_section_2c_data = JSON.parse( aon_section_2c_data_json );
    },
    
    renderTaskEntriesForSection5() {
        /*
         * Load / render existing entries to Section 5a...
         */        
        
        // Remove any existing entries so that we don't re-render...
        //$( '.tasks_section5 li:not(.preset)' ).remove();
        $( '.tasks_section5 li.from_2c' ).remove();
   
        // Loop over entries array...
        // We need to offset by the amount of preset examples that exist
        var entry_count = 7;
        var index_offset = 6;
        $.each( this.aon_section_2c_data, function( index ) {
            // Begin entry...            
            var aon_tasks_entry_section5_link = '<a href="#add-to-list" data-tasks-entry-id="' + ( index + index_offset ) + '" class="button rounded lozenge_item entry_' + entry_count + '">' + this.name.trim() + '</a>';
            $( '.tasks_section5' ).append( '<li class="tasks_entry from_2c">' + aon_tasks_entry_section5_link + '</li>' );
            entry_count++;
        });

    },
    
    renderData() {
        console.log( 'renderData - Section 5A');
        
        // Get any existing saved Tasks entry data from 2C...
        this.loadTasksDataFrom2c();
        
        // Render Tasks to 5A
        this.renderTaskEntriesForSection5();
    },
    
    addDataEntry() {
        console.log( 'addDataEntry - start' );
        // Default variables for data structure...
        var tasks_items = '';
        var impacts_items = '';
        var issues_items = '';
        var selected_task_impact_issue_items = '';
        
        // Push default data to data structure array...
        this.aon_section_5a_data.push( { 
            tasks_items,
            impacts_items,
            issues_items,
            selected_task_impact_issue_items
        } );
        
        console.log( 'addDataEntry: '  );
        console.table( this.aon_section_5a_data );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_5a_data_json = $( '#section_5a_data_json' ).val();
			//console.log( aon_section_5a_data_json );
            this.aon_section_5a_data = JSON.parse( aon_section_5a_data_json );
            
            console.table( this.aon_section_5a_data );
            
        } else if ( mode == 'load_demo' ) {
            // Using temp JSON source for now...
            var aon_section_5a_data_json = '[';
                aon_section_5a_data_json += '{"tasks_items":[{"name":"Weaving"},{"name":"Moodboards"},{"name":"Sourcing materials"}],"impacts_items":[{"name":"Conserve the oceans"},{"name":"Promote good health"},{"name":"Promote fairness and inclusive decision making"}],"issues_items":[{"name":"Reduce Waste"},{"name":"Education for all"},{"name":"Save energy"}],"selected_task_impact_issue_items":{ "task": "", "impact": "", "issue": ""}}';
                aon_section_5a_data_json += ']';

            this.aon_section_5a_data = JSON.parse( aon_section_5a_data_json );
            console.table( this.aon_section_5a_data );
            
        } else if ( mode == 'start' ) {
            this.addDataEntry();
            
        }
      
    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        this.aon_section_5a_data[ 0 ][ 'tasks_items' ] = this.tasks_applied_array;
        this.aon_section_5a_data[ 0 ][ 'impacts_items' ] = this.impacts_applied_array;
        this.aon_section_5a_data[ 0 ][ 'issues_items' ] = this.issues_applied_array;
        this.aon_section_5a_data[ 0 ][ 'selected_task_impact_issue_items' ] = this.selected_task_impact_issue_array;
        this.aon_section_5a_data[ 0 ][ 'business_purpose_statement' ] = this.business_purpose_statement;
        
        var jsonDataString = JSON.stringify( this.aon_section_5a_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '5A AJAX - START' );
        var meta = { 'section_5a_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '5A AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_5a_data );
      
    }

}